import { render, staticRenderFns } from "./remove-loan-modal.vue?vue&type=template&id=f8df86c8&"
import script from "./remove-loan-modal.vue?vue&type=script&lang=ts&"
export * from "./remove-loan-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports